module.exports = __webpack_public_path__ + "static/media/icon-heating.d1ff72fc.svg";